export function isFloat(val) {
  var floatRegex = /^-?\d+(?:[.,]\d*?)?$/
  if (!floatRegex.test(val)) return false

  val = parseFloat(val)
  if (isNaN(val)) return false
  return true
}
